<div class="main-section">
    <div class="feature-content">
        <div class="v2">
            <div class="top">
                <div class="title-area">
                    <div class="text">
                        <img alt="Logo" class="logo" src="../../../assets/images/MediaLab_Logo.png" />
                        <div class="title">Interior Design Tool</div>
                    </div>
                </div>
            </div>
            <div class="bottom">

                <accordion-form [allowDelete]="false" [allowDuplicate]="false">
                    <div header-title>
                        <div class="title">
                            Furniture Design Options
                        </div>
                    </div>
                    <div body>
                        <design-gallery [images]="globalInteriorDesigns" [interiorContentType]="interiorOrderAccordionContentTypes.Designs" [displayOnly]="true"></design-gallery>
                    </div>
                </accordion-form>

                <accordion-form [allowDelete]="false" [allowDuplicate]="false" [closedOnInit]="true">
                    <div header-title>
                        <div class="title">
                            Camera Angles
                        </div>
                    </div>
                    <div body>
                        <design-gallery [images]="angleAndEnvImages.CameraAngles" [interiorContentType]="interiorOrderAccordionContentTypes.CameraAngle" [displayOnly]="true"></design-gallery>
                    </div>
                </accordion-form>

                <accordion-form [allowDelete]="false" [allowDuplicate]="false" [closedOnInit]="true">
                    <div header-title>
                        <div class="title">
                            Exterior Environments
                        </div>
                    </div>
                    <div body>
                        <design-gallery [images]="angleAndEnvImages.Environments" [interiorContentType]="interiorOrderAccordionContentTypes.Environment" [displayOnly]="true"></design-gallery>
                    </div>
                </accordion-form>

            </div>
        </div>
    </div>

    <toast></toast>
</div>